@if (menuActions && menuActions.length > 0) {
    <div class="container">
        <app-actions-menu-select
            class="actions"
            [actions]="menuActions"
            [forceUsingSelectOptions]="true"
            (actionOnClick)="actionOnClick($event)"
            (click)="onMenuClick()"
            (clickOutside)="onOutsideMenuClick()">
        </app-actions-menu-select>
    </div>
}
